<div class="comment-container">
    <div class="comment-action">
        <button class="btn btn-primary btn-online-primary" (click)="openModal()">
            {{ "contractComment.createNewTitle" | translate }}
        </button>
    </div>
    <div class="grid-container">
        <ag-grid-angular
            style="width: 100%; height: 100%"
            [rowData]="contractComments"
            [columnDefs]="colDefs"
            [defaultColDef]="defaultColDef"
            (cellEditingStarted)="onCellEditingStarted($event)"
            (cellEditingStopped)="onCellEditingStopped($event)"
            [getRowStyle]="getRowStyle"
            (gridReady)="onGridReady($event)"
            [autoGroupColumnDef]="autoGroupColumnDef"
            [stopEditingWhenCellsLoseFocus]="true"

        />
    </div>
</div>
